import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.89219 11.3334C5.7582 12.5527 7.18532 13.3334 8.86291 13.3334C11.7968 13.3334 14.3857 10.9456 14.6455 8.00008C14.9052 5.05456 12.7375 2.66675 9.80359 2.66675C8.11976 2.66675 6.54954 3.45329 5.46806 4.68039C5.42452 4.67144 5.37944 4.66675 5.33325 4.66675L1.99992 4.66675C1.63173 4.66675 1.33325 4.96522 1.33325 5.33341C1.33325 5.7016 1.63173 6.00008 1.99992 6.00008L4.58355 6.00008C4.37694 6.42055 4.21984 6.86765 4.12092 7.33342H2.66659C2.2984 7.33342 1.99992 7.63189 1.99992 8.00008C1.99992 8.36827 2.2984 8.66675 2.66659 8.66675H4.00333C4.02011 9.13251 4.09835 9.57962 4.23079 10.0001H3.33325C2.96506 10.0001 2.66659 10.2986 2.66659 10.6667C2.66659 11.0349 2.96506 11.3334 3.33325 11.3334H4.89219ZM9.99969 5.66673C10.0323 5.29999 9.76024 5.00269 9.39205 5.00269C9.02386 5.00269 8.69896 5.29999 8.66636 5.66673L8.34171 9.319H11.0084C11.3766 9.319 11.7015 9.0217 11.7341 8.65495C11.7667 8.28821 11.4946 7.9909 11.1264 7.9909H9.7931L9.99969 5.66673Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}